import { PythonEditor, PythonEditorProps } from '@components/python-editor';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormPythonEditorProps<T = unknown> = FormFieldProps<PythonEditorProps, T>;

export function FormPythonEditor<T>(props: FormPythonEditorProps<T>) {
  const formFieldProps = useFormField({ ...props });

  return <PythonEditor {...props} {...formFieldProps} />;
}
